const { request, gql } = require('graphql-request');
const pageResults = require('graph-results-pager');

const { graphAPIEndpoints } = require('./../constants')
const { timestampToBlock } = require('./../utils');

module.exports = {
    async buryLeashUserRewards({block = undefined, timestamp = undefined, last_id = ""} = {}) {
        block = block ? block : timestamp ? (await timestampToBlock(timestamp)) : undefined;
        block = block ? `block: { number: ${block} }` : "";

        const result = await request(graphAPIEndpoints.buryLeash,
            gql`{
                bury(id: "0xa57d319b3cf3ad0e4d19770f71e63cf847263a0b", ${block}) {
                    id
                    totalSupply
                    users(first :1000, where: {id_gt : "${last_id}"}) {
                        id
                        xLeash
                    }
                }
            }`
        );

        return buryLeashUsersRewards.callback(result.bury);
    },
    async buryLeashUsers({block = undefined, timestamp = undefined} = {}) {
        return pageResults({
            api: graphAPIEndpoints.buryLeash,
            query: {
                entity: 'buries',
                selection: {
                    block: block ? { number: block } : timestamp ? { number: await timestampToBlock(timestamp) } : undefined,
                },
                properties: buryLeashUsersCallback.properties
            }
        }).then(results => buryLeashUsersCallback.callback(results)).catch(err => console.log(err));
    }
}

const buryLeashUsersCallback = {
    properties: [
        'id',
        'users {id, xLeash, xLeashIn, xLeashOut, xLeashMinted, xLeashBurned, xLeashOffset, xLeashAge, xLeashAgeDestroyed, leashStaked, leashStakedUSD, leashHarvested, leashHarvestedUSD, leashOut, leashIn, usdIn, leashOffset, usdOffset}',
        'totalSupply'
    ],

    callback(results) {
        return results.map(entry => ({
            id : entry.id,
            totalSupply: entry.totalSupply,
            users : entry.users.map(eachUser => ({
                id : eachUser.id,
                xLeash : Number(eachUser.xLeash),
                xLeashIn : Number(eachUser.xLeashIn),
                xLeashOut : Number(eachUser.xLeashOut),
                xLeashMinted : Number(eachUser.xLeashMinted),
                xLeashBurned : Number(eachUser.xLeashBurned),
                xLeashOffset : Number(eachUser.xLeashOffset),
                xLeashAge : Number(eachUser.xLeashAge),
                xLeashAgeDestroyed : Number(eachUser.xLeashAgeDestroyed),
                leashStaked : Number(eachUser.leashStaked),
                leashStakedUSD : Number(eachUser.leashStakedUSD),
                leashHarvested : Number(eachUser.leashHarvested),
                leashHarvestedUSD : Number(eachUser.leashHarvestedUSD),
                leashOut : Number(eachUser.leashOut),
                leashIn : Number(eachUser.leashIn),
                usdIn : Number(eachUser.usdIn),
                leashOffset : Number(eachUser.leashOffset),
                usdOffset : Number(eachUser.usdOffset)
            }))
        }))
    }
};

const buryLeashUsersRewards = {
    properties: [
        'id',
        'users {id, xLeash}',
        'totalSupply'
    ],

    callback(results) {
        return {
            id : results.id,
            totalSupply: Number(results.totalSupply),
            users : results && results.users ? results.users.map(eachUser => ({
                id : eachUser.id,
                xLeash : Number(eachUser.xLeash)
            })) : []
        }
    }
}